import loadable from '@loadable/component'

const widgetHtml = {
  variations: {
    default: loadable(() => import('./wrapper'))
  }
}

export default widgetHtml
